webpackJsonp([250867619812363],{

/***/ 183:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.previewQuery = exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Meta = __webpack_require__(6);
	
	var _Meta2 = _interopRequireDefault(_Meta);
	
	var _Banners = __webpack_require__(11);
	
	var _PageHelpers = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global graphql */
	var ArtsCultureGrid = function ArtsCultureGrid(_ref) {
	  var data = _ref.data;
	
	  var page = data.mortyPage;
	
	  // Filter out Featured Events page
	  var allPages = void 0;
	  if (data.allArtsCulture && data.allArtsCulture.edges) {
	    allPages = data.allArtsCulture.edges.filter(function (p) {
	      return p.node.title !== 'Featured Events';
	    });
	  }
	
	  // If there are events, add them to the data
	  var gridData = void 0;
	  if (allPages) {
	    gridData = allPages.concat(data.allArtsCulture.edges);
	  }
	
	  // Force ordering
	  var pageRoutes = ['/explore-downtown/arts-and-culture/theaters-and-music/', '/explore-downtown/arts-and-culture/art-galleries/', '/explore-downtown/arts-and-culture/richmond-street-art/'];
	
	  var orderedPages = [];
	  if (gridData) {
	    pageRoutes.forEach(function (route, _) {
	      var pgData = gridData.find(function (obj) {
	        return obj.node.route === route;
	      });
	      orderedPages.push(pgData);
	    });
	  }
	  // Filter out undefined values
	  var filteredPages = orderedPages.filter(Boolean);
	
	  // Render blocks
	  var blocks = void 0;
	  if (filteredPages) {
	    blocks = filteredPages.map(function (d) {
	      return _react2.default.createElement(_PageHelpers.ListGridItem, { key: d.node.id, page: d.node });
	    });
	  }
	
	  // Render banner
	  var Banner = function Banner(_ref2) {
	    var page = _ref2.page;
	
	    if (page.title !== 'Live Downtown' && page.title !== 'Explore Downtown' && page.title !== 'Work Downtown') {
	      return _react2.default.createElement(_Banners.ListGridBannerMinor, { page: page });
	    }
	    return _react2.default.createElement(_Banners.ListGridBanner, { page: page });
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Meta2.default, { page: page }),
	    _react2.default.createElement(Banner, { page: page }),
	    _react2.default.createElement(
	      'div',
	      { className: 'pv3 pv4-m pv5-l flex items-center justify-center' },
	      _react2.default.createElement(
	        'div',
	        { className: 'w-100' },
	        blocks
	      )
	    )
	  );
	};
	
	exports.default = ArtsCultureGrid;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	var previewQuery = exports.previewQuery = '\nquery ArtsCultureGrid($id: String!) {\n  mortyPage(id: { eq: $id }) {\n    title\n    route\n    subtitle\n    route\n    metaTitle\n    metaDescription\n    metaKeywords\n  }\n  allArtsCulture: allMortyPage(filter: {\n    route: { ne: "/dummy-page" }\n    section: { eq: "Arts and Culture" }\n}) {\n    edges {\n      node {\n        id\n        title\n        route\n        section\n        abstract\n        template\n        abstractPhotoAltText\n        abstractPhotoFocalPointX\n        metaDescription\n        abstractPhotoFocalPointY\n        abstractPhoto {\n          url\n        }\n      }\n    }\n  }\n}\n';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-arts-culture-grid-js-25246814b9c86eb62a96.js